import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const defaultDeliverySteps = [
    {
        step: "01",
        duration: "Weeks 1-2",
        title: "Discover",
        desc: "Start with a Process Data Audit — Mobikode reviews your process data and walks you through the benefits of process data analytics for your specific plant, with hands-on discussion and training for your team.",
        image: "/assets/datab/img2.png",
    },
    {
        step: "02",
        duration: "Weeks 3-4",
        title: "Design",
        desc: "Architecting cloud infrastructure, Lakehouse patterns, governance protocols, and networking integrations tailored to production standards.",
        image: "/assets/datab/img2.png",
    },
    {
        step: "03",
        duration: "Weeks 5-8",
        title: "Build",
        desc: "Implementing automated data pipelines, workspace configurations, Unity Catalog access control, and core computational clusters.",
        image: "/assets/datab/img2.png",
    },
    {
        step: "04",
        duration: "Weeks 9-10",
        title: "Launch",
        desc: "Validation, load testing, pipeline orchestration, user acceptance testing, and seamless migration to production workloads.",
        image: "/assets/datab/img2.png",
    },
    {
        step: "05",
        duration: "Ongoing",
        title: "Enable or Operate",
        desc: "Team upskilling, operational playbooks, monitoring dashboards, and ongoing enterprise support for scale and governance.",
        image: "/assets/datab/img2.png",
    },
];

export const IndustriesWeServe = ({
    badge = "From discovery to production",
    heading = "A clear path from platform design to go-live",
    subheading = "The schedule below is an indicative delivery approach. Final timing depends on scope, integrations, data readiness, and security review.",
    steps = defaultDeliverySteps,
}) => {
    const [hoveredIndex, setHoveredIndex] = useState(0);

    return (
        <section className="w-full bg-white pb-[60px] lg:pb-[100px]">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6 lg:mb-[40px] mb-[20px]">
                    <div>
                        <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora leading-[1.18] max-w-[476px]">
                            {heading}
                        </h2>
                    </div>
                    {/* <p className="text-[#01386A] font-graphik text-[14px] md:text-[16px] font-[500] max-w-[576px] leading-[1.65]">
                        {subheading}
                    </p> */}
                </div>

                <div className="flex flex-col lg:flex-row gap-4 lg:h-[496px] w-full items-stretch">
                    {steps.map((item, index) => {
                        const isHovered = hoveredIndex === index;

                        return (
                            <motion.div
                                key={item.step}
                                onMouseEnter={() => setHoveredIndex(index)}
                                layout
                                transition={{ duration: 0.45, ease: [0.25, 1, 0.5, 1] }}
                                className={`relative overflow-hidden cursor-pointer ${isHovered
                                    ? "lg:flex-[3.5] bg-[#01386A] flex flex-col justify-between"
                                    : "lg:flex-1 bg-white border border-[#BAC9D7] flex lg:flex-col items-center justify-between py-6 px-4 lg:py-8"
                                    }`}
                            >
                                {isHovered ? (
                                    <div className="w-full h-full flex flex-col justify-between relative z-10">
                                        <div className="w-full h-[210px] lg:h-[220px] overflow-hidden relative bg-[#021029]">
                                            <img
                                                src={item.image}
                                                alt={item.title}
                                                className="w-full h-full object-cover"
                                            />
                                        </div>

                                        <div className="p-6 lg:p-7 flex flex-col justify-between flex-1">
                                            <div className="flex items-start justify-between">
                                                <div>
                                                    <span className="block text-white font-graphik text-[14px] lg:text-[16px] font-[500] mb-1">
                                                        {item.duration}
                                                    </span>
                                                    <h3 className="text-white text-[16px] lg:text-[20px] font-[600] font-sora leading-tight">
                                                        {item.title}
                                                    </h3>
                                                </div>
                                                <span className="text-white/65 text-[16px] lg:text-[20px] font-[600] font-sora leading-none">
                                                    {item.step}
                                                </span>
                                            </div>

                                            <p className="text-white font-graphik text-[14px] sm:text-[16px] font-[500] leading-[1.6] mt-4">
                                                {item.description}
                                            </p>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="w-full h-full flex flex-row lg:flex-col items-center justify-between py-2 lg:py-4">
                                        <span className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora">
                                            {item.step}
                                        </span>

                                        <div className="hidden lg:block w-[1px] h-24 bg-[#01386A45]" />

                                        <span className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora lg:[writing-mode:vertical-rl] lg:rotate-180 tracking-wide">
                                            {item.title}
                                        </span>
                                    </div>
                                )}
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default IndustriesWeServe;